import { useNavigate } from "react-router-dom";
import { useLogin } from "./LoginContext";

export const useLogout = () => {
  const navigate = useNavigate();
  const { setUser } = useLogin();

  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    setUser(null);
    navigate("/login", { replace: true });
  };

  return logout;
};
